import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoChoVay,
  updateDataSearch,
} from "../../../actions/DuNoChoVay";
import { formatNumber } from "utils/currencyFormat";
export const TableDanhSach = () => {
  const dispatch = useDispatch();
  const listDuNoChoVayFull = useSelector((state) => state.listDuNoChoVayFull);

  const dataSearch = useSelector((state) => state.dataSearchDuNoChoVay);
  console.log(dataSearch, "TableDanhSach");
  useEffect(() => {
    dispatch(getListDuNoChoVay(dataSearch));
  }, []);

  return (
    <>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new border-main-mm">
            <div className="table-responsive table-new1">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th rowspan="2">STT</th>
                    <th rowspan="2">Kiểu vay</th>
                    <th className="" colspan="3">
                      Tổng dư nợ cho vay
                      <br />{" "}
                      <span className="color-do-bold">
                        {formatNumber(listDuNoChoVayFull.TongDuNo)}
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <th className="text-right">
                      Tổng dư nợ rủi ro
                      <br />{" "}
                      <span className="color-do-bold">
                        {formatNumber(listDuNoChoVayFull.Tong_NoRuiRo)}
                      </span>
                    </th>
                    <th className="text-right">
                      Tổng dư nợ xấu
                      <br />{" "}
                      <span className="color-do-bold">
                        {formatNumber(listDuNoChoVayFull.Tong_NoXau)}
                      </span>
                    </th>
                    <th className="text-right">
                      Tổng dư nợ thường
                      <br />{" "}
                      <span className="color-do-bold">
                        {formatNumber(listDuNoChoVayFull.TotalNoGoc)}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ContentTable
                    listDuNoChoVay={listDuNoChoVayFull.List}
                    fromDate={dataSearch.dateFrom}
                    toDate={dataSearch.dateTo}
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
